// #region Imports
import { defineComponent, reactive, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-server-page',
    // #endregion
    // #region Properties
    props: {
        templateUrl: {
            type: String,
            required: false,
            default: ''
        },
        dataObject: {
            type: Object,
            required: false,
            default() {
                return reactive({});
            }
        }
    },
    data: () => ({
        contentHtml: '',
        isLoading: true,
        isCreated: false
    }),
    // #endregion
    // #region Constructor
    beforeMount() {
        //Load
        this.loadData();
        //Flag
        this.isCreated = true;
        //Events
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        //Flag
        this.isCreated = false;
        //Events
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Watch
    watch: {
        "$route.params": {
            handler: function (value) {
                nextTick(() => {
                    if (!this.isCreated) {
                        return;
                    }
                    this.loadData();
                });
            },
            deep: true,
            immediate: false,
        },
    },
    // #endregion
    // #region Core
    methods: {
        async loadData() {
            // #region Check
            if (utils.isNullOrEmpty(this.templateUrl)) {
                this.isLoading = false;
                return;
            }
            // #endregion
            // #region Start
            this.isLoading = true;
            // #endregion
            // #region Load
            host.views.get(eval(this.templateUrl), { params: this.$route.query })
                .then(e => {
                if (e.data) {
                    //Content
                    if (e.data.body) {
                        this.contentHtml = e.data.body;
                    }
                    else if (e.data) {
                        this.contentHtml = e.data;
                    }
                    nextTick(() => {
                        //Title
                        if (e.data.title) {
                            host.pageMeta.title = e.data.title;
                        }
                        //Option
                        if (e.data.options) {
                            host.pageMeta.options = utils.mergeDeep(host.pageMeta.options ?? {}, e.data.options);
                        }
                        //Breadcrumb
                        if (e.data.breadcrumb) {
                            this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumb);
                        }
                    });
                }
                this.isLoading = false;
            })
                .catch(e => {
                this.contentHtml = '<pre>' + utils.getAxiosErrorMessage(e) + '</pre>';
                this.isLoading = false;
            });
            // #endregion
        }
    }
    // #endregion
});
// #endregion
